import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { columnGridMixin } from './column-grid-mixin';

export const ColumnCarousel = styled.div.attrs({
  className: createReadableClass({
    component: 'column-carousel',
    element: 'container'
  })
})`
  height: 100% !important;
  ${columnGridMixin}
`;
